module.exports = "/assets/data/6998558b2c5eaf043195ae33ed8f5611-NE66.data.json";